export const salesAvailabilityOptions = [
  { value: 0, label: "Available" },
  { value: 1, label: "Available for offers" },
  { value: 2, label: "Unavailable" },
];
